export default __webpack_public_path__ + "static/media/forwardArrow.746008ed.svg";